module.exports = __webpack_public_path__ + "img/xiangxiazhanhang.48a6ad28.png";